import { couponSummary } from './couponSummary';

describe('couponSummary', () => {
  it('shows the waived shipping fee as the discount for a plain FREE_SHIPPING coupon', () => {
    const summary = couponSummary({
      coupon: { couponType: 'FREE_SHIPPING' }, shipping: 5.95, couponValue: 0,
    });

    expect(summary.shippingOnly).toBe(true);
    expect(summary.freeShipping).toBe(true);
    expect(summary.waivedShipping).toBe(5.95);
    expect(summary.discountValue).toBe(5.95);
  });

  it('labels the discount instead of showing $0 when the cart owes no shipping', () => {
    const summary = couponSummary({
      coupon: { couponType: 'FREE_SHIPPING' }, shipping: 0, couponValue: 0,
    });

    expect(summary.waivedShipping).toBe(0);
    expect(summary.discountValue).toBe('Free Shipping');
  });

  it('does not treat *_WITH_FREE_SHIPPING combos as shipping-only', () => {
    ['FLAT_RATE_WITH_FREE_SHIPPING',
      'PERCENTAGE_WITH_FREE_SHIPPING',
      'PERCENTAGE_AND_FLAT_RATE_WITH_FREE_SHIPPING',
      'RETOUCHING_WITH_FREE_SHIPPING'].forEach((couponType) => {
      const summary = couponSummary({ coupon: { couponType }, shipping: 5.95, couponValue: 10 });

      expect(summary.shippingOnly).toBe(false);
      expect(summary.freeShipping).toBe(true);
      // Keeps the cart's own price discount.
      expect(summary.discountValue).toBe(10);
    });
  });

  it('leaves price-discount coupons alone', () => {
    ['FLAT_RATE', 'PERCENTAGE', 'PERCENTAGE_AND_FLAT_RATE', 'RETOUCHING',
      'VOLUME_DISCOUNT_FOR_PACKAGE'].forEach((couponType) => {
      const summary = couponSummary({ coupon: { couponType }, shipping: 5.95, couponValue: 10 });

      expect(summary.shippingOnly).toBe(false);
      expect(summary.freeShipping).toBe(false);
      expect(summary.discountValue).toBe(10);
    });
  });

  it('handles a cart with no coupon', () => {
    expect(couponSummary({ shipping: 5.95 })).toEqual({
      shippingOnly: false, freeShipping: false, waivedShipping: 5.95, discountValue: 0,
    });
  });
});
